<template>
	<div id="master">
		<menu-view></menu-view>
		<router-view></router-view>
	</div>
</template>

<script>

import MenuView from '@/components/super/SuperMenu'

export default {
	name: 'dashboard',

	data () {
		return {
			lang: {},
			logado: false
		}
	},

	created(){

		let token = this.$cookie.get('token');

		if(!token){
			this.$helper.pushRouteTo({ name: 'Login' });
		}else{
			this.logado = true;
		}

		if(!this.$locale.current() || this.$cookie.get("language") != this.$locale.current()){
			this.$locale.change(this.$cookie.get("language"));
		}

	},

	components: {
		'menu-view': MenuView
	}
}

</script>